
import React, {
  useEffect,
  useState,
} from "react";

import {
  FaUser,
  FaUserTag,
  FaShieldAlt,
  FaQuestionCircle,
  FaBirthdayCake,
  FaGlobe,
  FaMapMarkerAlt,
  FaSimCard,
  FaEnvelope,
  FaBars,
  FaExchangeAlt,
  FaChartBar,
  FaNewspaper,
  FaEllipsisH,
  FaChevronRight,
  FaTimes,
  FaSave,
  FaSpinner,
  FaCheckCircle,
  FaLock,
} from "react-icons/fa";

import {
  doc,
  getDoc,
  setDoc,
} from "firebase/firestore";

import {
  useNavigate,
} from "react-router-dom";

import {
  db,
} from "../firebase";

import "./Profile.css";


const UI_TRANSLATIONS = {
  'Loading security information...': { sw: 'Inapakia taarifa za usalama...', fr: 'Chargement des informations de sécurité...', es: 'Cargando información de seguridad...', pt: 'Carregando informações de segurança...', de: 'Sicherheitsinformationen werden geladen...', it: 'Caricamento delle informazioni di sicurezza...', ar: 'جارٍ تحميل معلومات الأمان...' },
  'Go back': { sw: 'Rudi nyuma', fr: 'Retour', es: 'Volver', pt: 'Voltar', de: 'Zurück', it: 'Indietro', ar: 'رجوع' },
  'Personal Information': { sw: 'Taarifa Binafsi', fr: 'Informations personnelles', es: 'Información personal', pt: 'Informações pessoais', de: 'Persönliche Informationen', it: 'Informazioni personali', ar: 'المعلومات الشخصية' },
  'Security': { sw: 'Usalama', fr: 'Sécurité', es: 'Seguridad', pt: 'Segurança', de: 'Sicherheit', it: 'Sicurezza', ar: 'الأمان' },
  'All security procedures successfully set': { sw: 'Taratibu zote za usalama zimewekwa kikamilifu', fr: 'Toutes les procédures de sécurité sont configurées', es: 'Todos los procedimientos de seguridad se configuraron correctamente', pt: 'Todos os procedimentos de segurança foram configurados', de: 'Alle Sicherheitsverfahren wurden erfolgreich eingerichtet', it: 'Tutte le procedure di sicurezza sono state configurate', ar: 'تم إعداد جميع إجراءات الأمان بنجاح' },
  'Your security information is fully secured.': { sw: 'Taarifa zako za usalama zimelindwa kikamilifu.', fr: 'Vos informations de sécurité sont entièrement protégées.', es: 'Tu información de seguridad está completamente protegida.', pt: 'Suas informações de segurança estão totalmente protegidas.', de: 'Ihre Sicherheitsinformationen sind vollständig geschützt.', it: 'Le tue informazioni di sicurezza sono completamente protette.', ar: 'معلومات الأمان الخاصة بك محمية بالكامل.' },
  'Security Setup': { sw: 'Mpangilio wa Usalama', fr: 'Configuration de sécurité', es: 'Configuración de seguridad', pt: 'Configuração de segurança', de: 'Sicherheitseinrichtung', it: 'Configurazione sicurezza', ar: 'إعداد الأمان' },
  'Complete all required security information.': { sw: 'Kamilisha taarifa zote za usalama zinazohitajika.', fr: 'Complétez toutes les informations de sécurité requises.', es: 'Completa toda la información de seguridad requerida.', pt: 'Complete todas as informações de segurança necessárias.', de: 'Vervollständigen Sie alle erforderlichen Sicherheitsinformationen.', it: 'Completa tutte le informazioni di sicurezza richieste.', ar: 'أكمل جميع معلومات الأمان المطلوبة.' },
  'Secure': { sw: 'Salama', fr: 'Sécurisé', es: 'Seguro', pt: 'Protegido', de: 'Gesichert', it: 'Protetto', ar: 'مؤمّن' },
  'Select your security question': { sw: 'Chagua swali lako la usalama', fr: 'Choisissez votre question de sécurité', es: 'Selecciona tu pregunta de seguridad', pt: 'Selecione sua pergunta de segurança', de: 'Wählen Sie Ihre Sicherheitsfrage', it: 'Seleziona la domanda di sicurezza', ar: 'اختر سؤال الأمان' },
  'Selected Question': { sw: 'Swali Lililochaguliwa', fr: 'Question sélectionnée', es: 'Pregunta seleccionada', pt: 'Pergunta selecionada', de: 'Ausgewählte Frage', it: 'Domanda selezionata', ar: 'السؤال المحدد' },
  'Your Answer': { sw: 'Jibu Lako', fr: 'Votre réponse', es: 'Tu respuesta', pt: 'Sua resposta', de: 'Ihre Antwort', it: 'La tua risposta', ar: 'إجابتك' },
  'Enter the answer that you will remember for verification.': { sw: 'Weka jibu utakalokumbuka kwa ajili ya uthibitishaji.', fr: 'Saisissez une réponse dont vous vous souviendrez pour la vérification.', es: 'Introduce una respuesta que recuerdes para la verificación.', pt: 'Digite uma resposta que você lembrará para verificação.', de: 'Geben Sie eine Antwort ein, an die Sie sich zur Überprüfung erinnern.', it: 'Inserisci una risposta che ricorderai per la verifica.', ar: 'أدخل إجابة يمكنك تذكرها للتحقق.' },
  'Cancel': { sw: 'Ghairi', fr: 'Annuler', es: 'Cancelar', pt: 'Cancelar', de: 'Abbrechen', it: 'Annulla', ar: 'إلغاء' },
  'Saving...': { sw: 'Inahifadhi...', fr: 'Enregistrement...', es: 'Guardando...', pt: 'Salvando...', de: 'Speichern...', it: 'Salvataggio...', ar: 'جارٍ الحفظ...' },
  'Save': { sw: 'Hifadhi', fr: 'Enregistrer', es: 'Guardar', pt: 'Salvar', de: 'Speichern', it: 'Salva', ar: 'حفظ' },
  'Menu': { sw: 'Menyu', fr: 'Menu', es: 'Menú', pt: 'Menu', de: 'Menü', it: 'Menu', ar: 'القائمة' },
  'Trades': { sw: 'Biashara', fr: 'Transactions', es: 'Operaciones', pt: 'Negociações', de: 'Handel', it: 'Scambi', ar: 'التداولات' },
  'Markets': { sw: 'Masoko', fr: 'Marchés', es: 'Mercados', pt: 'Mercados', de: 'Märkte', it: 'Mercati', ar: 'الأسواق' },
  'News': { sw: 'Habari', fr: 'Actualités', es: 'Noticias', pt: 'Notícias', de: 'Nachrichten', it: 'Notizie', ar: 'الأخبار' },
  'More': { sw: 'Zaidi', fr: 'Plus', es: 'Más', pt: 'Mais', de: 'Mehr', it: 'Altro', ar: 'المزيد' },
  'Real Name': { sw: 'Jina Halisi', fr: 'Nom réel', es: 'Nombre real', pt: 'Nome real', de: 'Echter Name', it: 'Nome reale', ar: 'الاسم الحقيقي' },
  'Enter your first name': { sw: 'Weka jina lako la kwanza', fr: 'Saisissez votre prénom', es: 'Introduce tu nombre', pt: 'Digite seu primeiro nome', de: 'Geben Sie Ihren Vornamen ein', it: 'Inserisci il tuo nome', ar: 'أدخل اسمك الأول' },
  'Last Name': { sw: 'Jina la Ukoo', fr: 'Nom de famille', es: 'Apellido', pt: 'Sobrenome', de: 'Nachname', it: 'Cognome', ar: 'اسم العائلة' },
  'Enter your last name': { sw: 'Weka jina lako la ukoo', fr: 'Saisissez votre nom de famille', es: 'Introduce tu apellido', pt: 'Digite seu sobrenome', de: 'Geben Sie Ihren Nachnamen ein', it: 'Inserisci il tuo cognome', ar: 'أدخل اسم العائلة' },
  'Nickname': { sw: 'Jina la Utani', fr: 'Surnom', es: 'Apodo', pt: 'Apelido', de: 'Spitzname', it: 'Soprannome', ar: 'الاسم المستعار' },
  'Enter your nickname (optional)': { sw: 'Weka jina lako la utani (si lazima)', fr: 'Saisissez votre surnom (facultatif)', es: 'Introduce tu apodo (opcional)', pt: 'Digite seu apelido (opcional)', de: 'Geben Sie Ihren Spitznamen ein (optional)', it: 'Inserisci il tuo soprannome (facoltativo)', ar: 'أدخل اسمك المستعار (اختياري)' },
  'Enter your nickname': { sw: 'Weka jina lako la utani', fr: 'Saisissez votre surnom', es: 'Introduce tu apodo', pt: 'Digite seu apelido', de: 'Geben Sie Ihren Spitznamen ein', it: 'Inserisci il tuo soprannome', ar: 'أدخل اسمك المستعار' },
  'Withdrawal Password': { sw: 'Nenosiri la Kutoa Fedha', fr: 'Mot de passe de retrait', es: 'Contraseña de retiro', pt: 'Senha de saque', de: 'Auszahlungskennwort', it: 'Password di prelievo', ar: 'كلمة مرور السحب' },
  'Minimum 4 characters. Numbers, letters, symbols, or any combination are allowed.': { sw: 'Angalau herufi 4. Nambari, herufi, alama au mchanganyiko wowote unaruhusiwa.', fr: '4 caractères minimum. Chiffres, lettres, symboles ou toute combinaison sont autorisés.', es: 'Mínimo 4 caracteres. Se permiten números, letras, símbolos o cualquier combinación.', pt: 'Mínimo de 4 caracteres. Números, letras, símbolos ou qualquer combinação são permitidos.', de: 'Mindestens 4 Zeichen. Zahlen, Buchstaben, Symbole oder Kombinationen sind erlaubt.', it: 'Minimo 4 caratteri. Sono ammessi numeri, lettere, simboli o qualsiasi combinazione.', ar: '٤ أحرف على الأقل. يُسمح بالأرقام والحروف والرموز أو أي مزيج منها.' },
  'Enter withdrawal password': { sw: 'Weka nenosiri la kutoa fedha', fr: 'Saisissez le mot de passe de retrait', es: 'Introduce la contraseña de retiro', pt: 'Digite a senha de saque', de: 'Auszahlungskennwort eingeben', it: 'Inserisci la password di prelievo', ar: 'أدخل كلمة مرور السحب' },
  'Security Question': { sw: 'Swali la Usalama', fr: 'Question de sécurité', es: 'Pregunta de seguridad', pt: 'Pergunta de segurança', de: 'Sicherheitsfrage', it: 'Domanda di sicurezza', ar: 'سؤال الأمان' },
  'Choose a security question and provide your answer': { sw: 'Chagua swali la usalama na utoe jibu lako', fr: 'Choisissez une question de sécurité et fournissez votre réponse', es: 'Elige una pregunta de seguridad y proporciona tu respuesta', pt: 'Escolha uma pergunta de segurança e forneça sua resposta', de: 'Wählen Sie eine Sicherheitsfrage und geben Sie Ihre Antwort ein', it: 'Scegli una domanda di sicurezza e fornisci la risposta', ar: 'اختر سؤال أمان وقدّم إجابتك' },
  'Birthday': { sw: 'Siku ya Kuzaliwa', fr: 'Date de naissance', es: 'Cumpleaños', pt: 'Data de nascimento', de: 'Geburtstag', it: 'Data di nascita', ar: 'تاريخ الميلاد' },
  'Enter your date of birth for verification': { sw: 'Weka tarehe yako ya kuzaliwa kwa uthibitishaji', fr: 'Saisissez votre date de naissance pour vérification', es: 'Introduce tu fecha de nacimiento para verificar', pt: 'Digite sua data de nascimento para verificação', de: 'Geben Sie Ihr Geburtsdatum zur Überprüfung ein', it: 'Inserisci la tua data di nascita per la verifica', ar: 'أدخل تاريخ ميلادك للتحقق' },
  'Country': { sw: 'Nchi', fr: 'Pays', es: 'País', pt: 'País', de: 'Land', it: 'Paese', ar: 'البلد' },
  'Enter your country for verification': { sw: 'Weka nchi yako kwa uthibitishaji', fr: 'Saisissez votre pays pour vérification', es: 'Introduce tu país para verificar', pt: 'Digite seu país para verificação', de: 'Geben Sie Ihr Land zur Überprüfung ein', it: 'Inserisci il tuo paese per la verifica', ar: 'أدخل بلدك للتحقق' },
  'Enter your country': { sw: 'Weka nchi yako', fr: 'Saisissez votre pays', es: 'Introduce tu país', pt: 'Digite seu país', de: 'Geben Sie Ihr Land ein', it: 'Inserisci il tuo paese', ar: 'أدخل بلدك' },
  'Region': { sw: 'Eneo', fr: 'Région', es: 'Región', pt: 'Região', de: 'Region', it: 'Regione', ar: 'المنطقة' },
  'Enter your region for verification': { sw: 'Weka eneo lako kwa uthibitishaji', fr: 'Saisissez votre région pour vérification', es: 'Introduce tu región para verificar', pt: 'Digite sua região para verificação', de: 'Geben Sie Ihre Region zur Überprüfung ein', it: 'Inserisci la tua regione per la verifica', ar: 'أدخل منطقتك للتحقق' },
  'Enter your region': { sw: 'Weka eneo lako', fr: 'Saisissez votre région', es: 'Introduce tu región', pt: 'Digite sua região', de: 'Geben Sie Ihre Region ein', it: 'Inserisci la tua regione', ar: 'أدخل منطقتك' },
  'Network': { sw: 'Mtandao wa Simu', fr: 'Réseau', es: 'Red', pt: 'Rede', de: 'Netzwerk', it: 'Rete', ar: 'الشبكة' },
  'Enter your mobile network': { sw: 'Weka mtandao wako wa simu', fr: 'Saisissez votre réseau mobile', es: 'Introduce tu red móvil', pt: 'Digite sua rede móvel', de: 'Geben Sie Ihr Mobilfunknetz ein', it: 'Inserisci la tua rete mobile', ar: 'أدخل شبكة الهاتف المحمول' },
  'Enter your network': { sw: 'Weka mtandao wako', fr: 'Saisissez votre réseau', es: 'Introduce tu red', pt: 'Digite sua rede', de: 'Geben Sie Ihr Netzwerk ein', it: 'Inserisci la tua rete', ar: 'أدخل شبكتك' },
  'Email Address': { sw: 'Anwani ya Barua Pepe', fr: 'Adresse e-mail', es: 'Correo electrónico', pt: 'Endereço de e-mail', de: 'E-Mail-Adresse', it: 'Indirizzo e-mail', ar: 'عنوان البريد الإلكتروني' },
  'Enter your email address for verification': { sw: 'Weka barua pepe yako kwa uthibitishaji', fr: 'Saisissez votre adresse e-mail pour vérification', es: 'Introduce tu correo electrónico para verificar', pt: 'Digite seu e-mail para verificação', de: 'Geben Sie Ihre E-Mail-Adresse zur Überprüfung ein', it: 'Inserisci il tuo indirizzo e-mail per la verifica', ar: 'أدخل بريدك الإلكتروني للتحقق' },
  'Enter your email address': { sw: 'Weka anwani yako ya barua pepe', fr: 'Saisissez votre adresse e-mail', es: 'Introduce tu correo electrónico', pt: 'Digite seu endereço de e-mail', de: 'Geben Sie Ihre E-Mail-Adresse ein', it: 'Inserisci il tuo indirizzo e-mail', ar: 'أدخل عنوان بريدك الإلكتروني' },
  'What is your age?': { sw: 'Una umri gani?', fr: 'Quel âge avez-vous ?', es: '¿Qué edad tienes?', pt: 'Qual é a sua idade?', de: 'Wie alt sind Sie?', it: 'Quanti anni hai?', ar: 'كم عمرك؟' },
  'What is your lucky number?': { sw: 'Nambari yako ya bahati ni ipi?', fr: 'Quel est votre chiffre porte-bonheur ?', es: '¿Cuál es tu número de la suerte?', pt: 'Qual é o seu número da sorte?', de: 'Was ist Ihre Glückszahl?', it: 'Qual è il tuo numero fortunato?', ar: 'ما رقم حظك؟' },
  'What was the name of your first school?': { sw: 'Shule yako ya kwanza iliitwa nani?', fr: 'Quel était le nom de votre première école ?', es: '¿Cómo se llamaba tu primera escuela?', pt: 'Qual era o nome da sua primeira escola?', de: 'Wie hieß Ihre erste Schule?', it: 'Come si chiamava la tua prima scuola?', ar: 'ما اسم مدرستك الأولى؟' },
  'What is your favorite childhood nickname?': { sw: 'Jina gani la utani ulilopenda utotoni?', fr: 'Quel était votre surnom préféré dans l’enfance ?', es: '¿Cuál era tu apodo favorito de la infancia?', pt: 'Qual era seu apelido favorito na infância?', de: 'Was war Ihr liebster Spitzname aus der Kindheit?', it: 'Qual era il tuo soprannome preferito da bambino?', ar: 'ما لقبك المفضل في الطفولة؟' },
  'What was the name of your first pet?': { sw: 'Mnyama wako wa kwanza kipenzi aliitwa nani?', fr: 'Comment s’appelait votre premier animal de compagnie ?', es: '¿Cómo se llamaba tu primera mascota?', pt: 'Qual era o nome do seu primeiro animal de estimação?', de: 'Wie hieß Ihr erstes Haustier?', it: 'Come si chiamava il tuo primo animale domestico?', ar: 'ما اسم أول حيوان أليف لك؟' },
  'What is your favorite childhood memory?': { sw: 'Kumbukumbu gani ya utotoni unayoipenda zaidi?', fr: 'Quel est votre meilleur souvenir d’enfance ?', es: '¿Cuál es tu recuerdo favorito de la infancia?', pt: 'Qual é sua lembrança favorita da infância?', de: 'Was ist Ihre liebste Kindheitserinnerung?', it: 'Qual è il tuo ricordo d’infanzia preferito?', ar: 'ما ذكراك المفضلة من الطفولة؟' },
  'What is your mother’s maiden name?': { sw: 'Jina la mama yako kabla ya kuolewa ni lipi?', fr: 'Quel est le nom de jeune fille de votre mère ?', es: '¿Cuál es el apellido de soltera de tu madre?', pt: 'Qual é o nome de solteira da sua mãe?', de: 'Wie lautet der Geburtsname Ihrer Mutter?', it: 'Qual è il cognome da nubile di tua madre?', ar: 'ما اسم عائلة والدتك قبل الزواج؟' },
  "What is your mother's maiden name?": { sw: 'Jina la mama yako kabla ya kuolewa ni lipi?', fr: 'Quel est le nom de jeune fille de votre mère ?', es: '¿Cuál es el apellido de soltera de tu madre?', pt: 'Qual é o nome de solteira da sua mãe?', de: 'Wie lautet der Geburtsname Ihrer Mutter?', it: 'Qual è il cognome da nubile di tua madre?', ar: 'ما اسم عائلة والدتك قبل الزواج؟' },
  'What city were you born in?': { sw: 'Ulizaliwa katika jiji gani?', fr: 'Dans quelle ville êtes-vous né(e) ?', es: '¿En qué ciudad naciste?', pt: 'Em que cidade você nasceu?', de: 'In welcher Stadt wurden Sie geboren?', it: 'In quale città sei nato/a?', ar: 'في أي مدينة وُلدت؟' },
  'Enter your lucky number': { sw: 'Weka nambari yako ya bahati', fr: 'Saisissez votre chiffre porte-bonheur', es: 'Introduce tu número de la suerte', pt: 'Digite seu número da sorte', de: 'Geben Sie Ihre Glückszahl ein', it: 'Inserisci il tuo numero fortunato', ar: 'أدخل رقم حظك' },
  'Enter your age': { sw: 'Weka umri wako', fr: 'Saisissez votre âge', es: 'Introduce tu edad', pt: 'Digite sua idade', de: 'Geben Sie Ihr Alter ein', it: 'Inserisci la tua età', ar: 'أدخل عمرك' },
  'Enter your answer': { sw: 'Weka jibu lako', fr: 'Saisissez votre réponse', es: 'Introduce tu respuesta', pt: 'Digite sua resposta', de: 'Geben Sie Ihre Antwort ein', it: 'Inserisci la tua risposta', ar: 'أدخل إجابتك' },
  'Please select a security question.': { sw: 'Tafadhali chagua swali la usalama.', fr: 'Veuillez sélectionner une question de sécurité.', es: 'Selecciona una pregunta de seguridad.', pt: 'Selecione uma pergunta de segurança.', de: 'Bitte wählen Sie eine Sicherheitsfrage.', it: 'Seleziona una domanda di sicurezza.', ar: 'يرجى اختيار سؤال أمان.' },
  'Please enter the answer to your security question.': { sw: 'Tafadhali weka jibu la swali lako la usalama.', fr: 'Veuillez saisir la réponse à votre question de sécurité.', es: 'Introduce la respuesta a tu pregunta de seguridad.', pt: 'Digite a resposta à sua pergunta de segurança.', de: 'Bitte geben Sie die Antwort auf Ihre Sicherheitsfrage ein.', it: 'Inserisci la risposta alla domanda di sicurezza.', ar: 'يرجى إدخال إجابة سؤال الأمان.' },
  'Security question secured successfully.': { sw: 'Swali la usalama limehifadhiwa kwa mafanikio.', fr: 'Question de sécurité enregistrée avec succès.', es: 'Pregunta de seguridad guardada correctamente.', pt: 'Pergunta de segurança salva com sucesso.', de: 'Sicherheitsfrage erfolgreich gespeichert.', it: 'Domanda di sicurezza salvata correttamente.', ar: 'تم حفظ سؤال الأمان بنجاح.' },
  'Failed to save security question. Please try again.': { sw: 'Imeshindwa kuhifadhi swali la usalama. Tafadhali jaribu tena.', fr: 'Échec de l’enregistrement de la question de sécurité. Réessayez.', es: 'No se pudo guardar la pregunta de seguridad. Inténtalo de nuevo.', pt: 'Falha ao salvar a pergunta de segurança. Tente novamente.', de: 'Sicherheitsfrage konnte nicht gespeichert werden. Bitte erneut versuchen.', it: 'Impossibile salvare la domanda di sicurezza. Riprova.', ar: 'تعذر حفظ سؤال الأمان. يُرجى المحاولة مرة أخرى.' },
  'Please enter the required information.': { sw: 'Tafadhali weka taarifa zinazohitajika.', fr: 'Veuillez saisir les informations requises.', es: 'Introduce la información obligatoria.', pt: 'Digite as informações obrigatórias.', de: 'Bitte geben Sie die erforderlichen Informationen ein.', it: 'Inserisci le informazioni richieste.', ar: 'يرجى إدخال المعلومات المطلوبة.' },
  'Withdrawal password must be at least 4 characters.': { sw: 'Nenosiri la kutoa fedha lazima liwe na angalau herufi 4.', fr: 'Le mot de passe de retrait doit contenir au moins 4 caractères.', es: 'La contraseña de retiro debe tener al menos 4 caracteres.', pt: 'A senha de saque deve ter pelo menos 4 caracteres.', de: 'Das Auszahlungskennwort muss mindestens 4 Zeichen enthalten.', it: 'La password di prelievo deve contenere almeno 4 caratteri.', ar: 'يجب أن تتكون كلمة مرور السحب من ٤ أحرف على الأقل.' },
  'Withdrawal password cannot be the same as your username.': { sw: 'Nenosiri la kutoa fedha haliwezi kuwa sawa na jina lako la mtumiaji.', fr: 'Le mot de passe de retrait ne peut pas être identique à votre nom d’utilisateur.', es: 'La contraseña de retiro no puede ser igual a tu nombre de usuario.', pt: 'A senha de saque não pode ser igual ao seu nome de usuário.', de: 'Das Auszahlungskennwort darf nicht mit Ihrem Benutzernamen identisch sein.', it: 'La password di prelievo non può essere uguale al nome utente.', ar: 'لا يمكن أن تكون كلمة مرور السحب مطابقة لاسم المستخدم.' },
  'Saved successfully.': { sw: 'Imehifadhiwa kwa mafanikio.', fr: 'Enregistré avec succès.', es: 'Guardado correctamente.', pt: 'Salvo com sucesso.', de: 'Erfolgreich gespeichert.', it: 'Salvato correttamente.', ar: 'تم الحفظ بنجاح.' },
  'Failed to save information. Please try again.': { sw: 'Imeshindwa kuhifadhi taarifa. Tafadhali jaribu tena.', fr: 'Échec de l’enregistrement des informations. Réessayez.', es: 'No se pudo guardar la información. Inténtalo de nuevo.', pt: 'Falha ao salvar as informações. Tente novamente.', de: 'Informationen konnten nicht gespeichert werden. Bitte erneut versuchen.', it: 'Impossibile salvare le informazioni. Riprova.', ar: 'تعذر حفظ المعلومات. يُرجى المحاولة مرة أخرى.' },
  'Please log in again.': { sw: 'Tafadhali ingia tena.', fr: 'Veuillez vous reconnecter.', es: 'Inicia sesión de nuevo.', pt: 'Faça login novamente.', de: 'Bitte melden Sie sich erneut an.', it: 'Accedi di nuovo.', ar: 'يرجى تسجيل الدخول مرة أخرى.' },
  'This security information is already secured.': { sw: 'Taarifa hii ya usalama tayari imelindwa.', fr: 'Ces informations de sécurité sont déjà protégées.', es: 'Esta información de seguridad ya está protegida.', pt: 'Estas informações de segurança já estão protegidas.', de: 'Diese Sicherheitsinformationen sind bereits gesichert.', it: 'Queste informazioni di sicurezza sono già protette.', ar: 'معلومات الأمان هذه محمية بالفعل.' },
  'Secured': { sw: 'Imelindwa', fr: 'Sécurisé', es: 'Protegido', pt: 'Protegido', de: 'Gesichert', it: 'Protetto', ar: 'مؤمّن' },
};

const normalizeLanguage = (value) => {
  const code = String(value || "en").toLowerCase().split("-")[0];
  return ["en", "fr", "sw", "pt", "es", "ar", "zh", "hi", "bn", "ru", "de", "it", "nl", "tr", "ja", "ko", "vi", "th", "id", "ms", "ur", "fa", "ha", "yo", "zu", "am", "so", "rw", "lg", "af"].includes(code) ? code : "en";
};

/* =========================================================
   SECURITY QUESTIONS
========================================================= */

const securityQuestions = [

  "What is your age?",

  "What is your lucky number?",

  "What was the name of your first school?",

  "What is your favorite childhood nickname?",

  "What was the name of your first pet?",

  "What is your favorite childhood memory?",

  "What is your mother's maiden name?",

  "What city were you born in?",

];


/* =========================================================
   SECURITY FIELD CONFIGURATION
========================================================= */

const securityFields = [

  {
    key: "realName",

    title: "Real Name",

    description:
      "Enter your first name",

    placeholder:
      "Enter your first name",

    icon: <FaUser />,

    type: "text",
  },


  {
    key: "lastName",

    title: "Last Name",

    description:
      "Enter your last name",

    placeholder:
      "Enter your last name",

    icon: <FaUser />,

    type: "text",
  },


  {
    key: "nickName",

    title: "Nickname",

    description:
      "Enter your nickname (optional)",

    placeholder:
      "Enter your nickname",

    icon: <FaUserTag />,

    type: "text",

    optional: true,
  },


  {
    key: "withdrawPassword",

    title: "Withdrawal Password",

    description:
      "Minimum 4 characters. Numbers, letters, symbols, or any combination are allowed.",

    placeholder:
      "Enter withdrawal password",

    icon: <FaShieldAlt />,

    type: "password",
  },


  {
    key: "securityQuestion",

    title: "Security Question",

    description:
      "Choose a security question and provide your answer",

    placeholder:
      "",

    icon: <FaQuestionCircle />,

    type: "security-question",
  },


  {
    key: "birthDay",

    title: "Birthday",

    description:
      "Enter your date of birth for verification",

    placeholder:
      "",

    icon: <FaBirthdayCake />,

    type: "date",
  },


  {
    key: "country",

    title: "Country",

    description:
      "Enter your country for verification",

    placeholder:
      "Enter your country",

    icon: <FaGlobe />,

    type: "text",
  },


  {
    key: "region",

    title: "Region",

    description:
      "Enter your region for verification",

    placeholder:
      "Enter your region",

    icon: <FaMapMarkerAlt />,

    type: "text",
  },


  {
    key: "network",

    title: "Network",

    description:
      "Enter your mobile network",

    placeholder:
      "Enter your network",

    icon: <FaSimCard />,

    type: "text",
  },


  {
    key: "email",

    title: "Email Address",

    description:
      "Enter your email address for verification",

    placeholder:
      "Enter your email address",

    icon: <FaEnvelope />,

    type: "email",
  },

];


/* =========================================================
   MORE / PROFILE PAGE
========================================================= */

export default function More() {

  const [language, setLanguage] = useState(() => normalizeLanguage(localStorage.getItem("language") || "en"));

  useEffect(() => {
    const syncLanguage = (event) => {
      const eventLanguage = event?.detail?.language || event?.detail?.lang || event?.detail;
      setLanguage(normalizeLanguage(eventLanguage || localStorage.getItem("language") || "en"));
    };
    window.addEventListener("languageChanged", syncLanguage);
    window.addEventListener("storage", syncLanguage);
    return () => {
      window.removeEventListener("languageChanged", syncLanguage);
      window.removeEventListener("storage", syncLanguage);
    };
  }, []);

  const t = (value) => {
    const lang = normalizeLanguage(language);
    return UI_TRANSLATIONS[value]?.[lang] || UI_TRANSLATIONS[value]?.[String(language || "en").toLowerCase()] || value;
  };

  const navigate =
    useNavigate();


  /* =======================================================
     USERNAME
  ======================================================= */

  const username =
    localStorage.getItem(
      "username"
    ) || "";


  /* =======================================================
     SECURITY DATA
  ======================================================= */

  const [
    securityData,
    setSecurityData,
  ] = useState({});


  /* =======================================================
     LOADING
  ======================================================= */

  const [
    loading,
    setLoading,
  ] = useState(true);


  /* =======================================================
     SAVING
  ======================================================= */

  const [
    saving,
    setSaving,
  ] = useState(false);


  /* =======================================================
     SELECTED FIELD
  ======================================================= */

  const [
    selectedField,
    setSelectedField,
  ] = useState(null);


  /* =======================================================
     INPUT VALUE
  ======================================================= */

  const [
    inputValue,
    setInputValue,
  ] = useState("");


  /* =======================================================
     SELECTED QUESTION
  ======================================================= */

  const [
    selectedQuestion,
    setSelectedQuestion,
  ] = useState("");


  /* =======================================================
     MESSAGE
  ======================================================= */

  const [
    message,
    setMessage,
  ] = useState("");


  /* =======================================================
     LOAD SECURITY DATA
  ======================================================= */

  useEffect(() => {

    const loadSecurityData =
      async () => {

        try {

          setLoading(true);


          if (!username) {

            setSecurityData({});

            return;

          }


          const securityRef =
            doc(
              db,
              "security",
              username
            );


          const securitySnapshot =
            await getDoc(
              securityRef
            );


          if (
            securitySnapshot.exists()
          ) {

            setSecurityData(
              securitySnapshot.data()
            );

          } else {

            setSecurityData({});

          }

        } catch (error) {

          console.error(
            "Security data loading error:",
            error
          );

          setSecurityData({});

        } finally {

          setLoading(false);

        }

      };


    loadSecurityData();

  }, [username]);


  /* =======================================================
     CHECK IF FIELD IS SECURED
  ======================================================= */

  const isFieldSecured = (
    field
  ) => {

    /* -------------------------------------------------------
       SECURITY QUESTION
       Requires BOTH question and answer
    ------------------------------------------------------- */

    if (
      field.key ===
      "securityQuestion"
    ) {

      return Boolean(
        securityData.securityQuestion &&
        securityData.securityAnswer
      );

    }


    /* -------------------------------------------------------
       NORMAL FIELD
    ------------------------------------------------------- */

    const value =
      securityData[field.key];


    return Boolean(
      value !== undefined &&
      value !== null &&
      String(value).trim() !== ""
    );

  };


  /* =======================================================
     CHECK ALL SECURITY PROCEDURES
  ======================================================= */

  const requiredFields =
    securityFields.filter(
      (field) =>
        !field.optional
    );


  const allSecurityProceduresComplete =
    requiredFields.every(
      (field) =>
        isFieldSecured(field)
    );


  /* =======================================================
     WITHDRAWAL PASSWORD VALIDATION
  ======================================================= */

  const validateWithdrawPassword = (
    value
  ) => {

    const password =
      String(
        value || ""
      ).trim();


    const currentUsername =
      String(
        username || ""
      ).trim();


    /* -------------------------------------------------------
       MINIMUM 4 CHARACTERS
    ------------------------------------------------------- */

    if (
      password.length < 4
    ) {

      return (
        t("Withdrawal password must be at least 4 characters.")
      );

    }


    /* -------------------------------------------------------
       CANNOT BE SAME AS USERNAME
       Case-insensitive comparison
       
       Example:
       john
       JOHN
       John
       jOhN

       All will be rejected if username is "john".
    ------------------------------------------------------- */

    if (
      currentUsername &&
      password.toLowerCase() ===
        currentUsername.toLowerCase()
    ) {

      return (
        t("Withdrawal password cannot be the same as your username.")
      );

    }


    /* -------------------------------------------------------
       NO OTHER RESTRICTIONS
       
       Numbers:
       1234       ✅

       Letters:
       abcd       ✅

       Mixed:
       ab12       ✅

       Symbols:
       @@@@       ✅

       Mixed:
       A@12       ✅
    ------------------------------------------------------- */

    return "";

  };


  /* =======================================================
     BACK
  ======================================================= */

  const handleBack = () => {

    navigate(-1);

  };


  /* =======================================================
     OPEN FIELD
  ======================================================= */

  const handleItemClick = (
    field
  ) => {

    /*
     * Once secured, do NOT allow
     * the user to edit it again.
     */

    if (
      isFieldSecured(field)
    ) {

      return;

    }


    setSelectedField(
      field
    );

    setMessage("");


    /* =====================================================
       SECURITY QUESTION
    ===================================================== */

    if (
      field.key ===
      "securityQuestion"
    ) {

      setSelectedQuestion("");

      setInputValue("");

      return;

    }


    /* =====================================================
       NORMAL FIELD
    ===================================================== */

    setInputValue("");

    setSelectedQuestion("");

  };


  /* =======================================================
     CLOSE MODAL
  ======================================================= */

  const closeEditor = () => {

    if (saving) {

      return;

    }


    setSelectedField(
      null
    );

    setInputValue("");

    setSelectedQuestion("");

    setMessage("");

  };


  /* =======================================================
     SELECT SECURITY QUESTION
  ======================================================= */

  const handleQuestionSelect = (
    question
  ) => {

    setSelectedQuestion(
      question
    );

    setInputValue("");

    setMessage("");

  };


  /* =======================================================
     SAVE SECURITY QUESTION
  ======================================================= */

  const saveSecurityQuestion =
    async () => {

      if (
        !selectedQuestion
      ) {

        setMessage(
          t("Please select a security question.")
        );

        return;

      }


      const answer =
        String(
          inputValue || ""
        ).trim();


      if (!answer) {

        setMessage(
          t("Please enter the answer to your security question.")
        );

        return;

      }


      try {

        setSaving(true);

        setMessage("");


        const securityRef =
          doc(
            db,
            "security",
            username
          );


        await setDoc(
          securityRef,
          {

            username,

            securityQuestion:
              selectedQuestion,

            securityAnswer:
              answer,

            updatedAt:
              new Date(),

          },
          {
            merge: true,
          }
        );


        setSecurityData(
          (previous) => ({

            ...previous,

            securityQuestion:
              selectedQuestion,

            securityAnswer:
              answer,

          })
        );


        setMessage(
          t("Security question secured successfully.")
        );


        setTimeout(() => {

          setSelectedField(
            null
          );

          setSelectedQuestion("");

          setInputValue("");

          setMessage("");

        }, 700);


      } catch (error) {

        console.error(
          "Security question save error:",
          error
        );


        setMessage(
          t("Failed to save security question. Please try again.")
        );

      } finally {

        setSaving(false);

      }

    };


  /* =======================================================
     SAVE NORMAL FIELD
  ======================================================= */

  const saveNormalField =
    async () => {

      const value =
        String(
          inputValue || ""
        ).trim();


      /* =====================================================
         REQUIRED FIELD VALIDATION
      ===================================================== */

      if (
        !value &&
        !selectedField.optional
      ) {

        setMessage(
          t("Please enter the required information.")
        );

        return;

      }


      /* =====================================================
         WITHDRAWAL PASSWORD VALIDATION
      ===================================================== */

      if (
        selectedField.key ===
        "withdrawPassword"
      ) {

        const validationError =
          validateWithdrawPassword(
            value
          );


        if (
          validationError
        ) {

          setMessage(
            validationError
          );

          return;

        }

      }


      /* =====================================================
         SAVE TO FIREBASE
      ===================================================== */

      try {

        setSaving(true);

        setMessage("");


        const securityRef =
          doc(
            db,
            "security",
            username
          );


        await setDoc(
          securityRef,
          {

            username,

            [selectedField.key]:
              value,

            updatedAt:
              new Date(),

          },
          {
            merge: true,
          }
        );


        /* ===================================================
           UPDATE LOCAL STATE
        =================================================== */

        setSecurityData(
          (previous) => ({

            ...previous,

            [selectedField.key]:
              value,

          })
        );


        setMessage(
          t("Saved successfully.")
        );


        /* ===================================================
           CLOSE AFTER SUCCESS
        =================================================== */

        setTimeout(() => {

          setSelectedField(
            null
          );

          setInputValue("");

          setMessage("");

        }, 700);


      } catch (error) {

        console.error(
          "Security save error:",
          error
        );


        setMessage(
          t("Failed to save information. Please try again.")
        );


      } finally {

        setSaving(false);

      }

    };


  /* =======================================================
     SAVE
  ======================================================= */

  const handleSave = async () => {

    /* =====================================================
       USERNAME CHECK
    ===================================================== */

    if (!username) {

      setMessage(
        t("Please log in again.")
      );

      return;

    }


    /* =====================================================
       FIELD CHECK
    ===================================================== */

    if (!selectedField) {

      return;

    }


    /* =====================================================
       SECURITY CHECK
       
       Do not allow saving an already
       secured field.
    ===================================================== */

    if (
      isFieldSecured(
        selectedField
      )
    ) {

      setMessage(
        t("This security information is already secured.")
      );

      return;

    }


    /* =====================================================
       SECURITY QUESTION
    ===================================================== */

    if (
      selectedField.key ===
      "securityQuestion"
    ) {

      await saveSecurityQuestion();

      return;

    }


    /* =====================================================
       NORMAL FIELD
    ===================================================== */

    await saveNormalField();

  };


  /* =======================================================
     FORMAT DISPLAY VALUE
  ======================================================= */

  const getDisplayValue = (
    field
  ) => {

    const value =
      securityData[field.key];


    /* =====================================================
       SECURITY QUESTION
    ===================================================== */

    if (
      field.key ===
      "securityQuestion"
    ) {

      if (
        securityData.securityQuestion &&
        securityData.securityAnswer
      ) {

        return t("Secured");

      }

      return "";

    }


    /* =====================================================
       EMPTY
    ===================================================== */

    if (
      value === undefined ||
      value === null ||
      value === ""
    ) {

      return "";

    }


    /* =====================================================
       HIDE WITHDRAWAL PASSWORD
    ===================================================== */

    if (
      field.key ===
      "withdrawPassword"
    ) {

      return "••••••••";

    }


    return String(
      value
    );

  };


  /* =======================================================
     ANSWER PLACEHOLDER
  ======================================================= */

  const getAnswerPlaceholder = () => {

    if (
      selectedQuestion ===
      "What is your lucky number?"
    ) {

      return t("Enter your lucky number");

    }


    if (
      selectedQuestion ===
      "What is your age?"
    ) {

      return t("Enter your age");

    }


    return t("Enter your answer");

  };


  /* =======================================================
     BOTTOM NAVIGATION
  ======================================================= */

  const handleMenuClick = () => {

    navigate("/");

  };


  const handleTradesClick = () => {

    navigate("/market-trade");

  };


  const handleMarketsClick = () => {

    navigate("/markets");

  };


  const handleNewsClick = () => {

    navigate("/news");

  };


  const handleMoreClick = () => {

    navigate("/more");

  };


  /* =======================================================
     KEYBOARD
  ======================================================= */

  const handleInputKeyDown = (
    event
  ) => {

    if (
      event.key ===
      "Enter"
    ) {

      handleSave();

    }

  };


  /* =======================================================
     LOADING
  ======================================================= */

  if (loading) {

    return (

      <div className="more-page">

        <div className="more-loading">

          <FaSpinner
            className="more-loading-icon"
          />

          <span>
            {t("Loading security information...")}
          </span>

        </div>

      </div>

    );

  }


  /* =======================================================
     RETURN
  ======================================================= */

  return (

    <div className="more-page">


      {/* ===================================================
          MAIN CONTENT
      =================================================== */}

      <div className="more-content">


        {/* =================================================
            HEADER
        ================================================= */}

        <div className="more-header">


          <div className="more-header-left">


            {/* =============================================
                BACK
            ============================================= */}

            <button
              type="button"
              className="more-back-btn"
              onClick={
                handleBack
              }
              aria-label={t("Go back")}
            >

              ‹

            </button>


            {/* =============================================
                TITLE
            ============================================= */}

            <div className="more-header-title">

              <h1>
                {t("Personal Information")}
              </h1>

              <div className="more-release">
                Security
              </div>

            </div>


          </div>


        </div>


        {/* =================================================
            SECURITY STATUS
        ================================================= */}

        <div
          className={
            allSecurityProceduresComplete
              ? "security-status complete"
              : "security-status"
          }
        >

          {allSecurityProceduresComplete ? (

            <>

              <FaCheckCircle />

              <div>

                <strong>
                  {t("All security procedures successfully set")}
                </strong>

                <span>
                  {t("Your security information is fully secured.")}
                </span>

              </div>

            </>

          ) : (

            <>

              <FaLock />

              <div>

                <strong>
                  {t("Security Setup")}
                </strong>

                <span>
                  {t("Complete all required security information.")}
                </span>

              </div>

            </>

          )}

        </div>


        {/* =================================================
            SECURITY LIST
        ================================================= */}

        <div className="more-list">

          {securityFields.map(
            (field) => {

              const secured =
                isFieldSecured(
                  field
                );


              const displayValue =
                getDisplayValue(
                  field
                );


              return (

                <button
                  key={
                    field.key
                  }
                  type="button"
                  className={
                    secured
                      ? "more-item secured"
                      : "more-item"
                  }
                  onClick={() =>
                    handleItemClick(
                      field
                    )
                  }
                  disabled={
                    secured
                  }
                >


                  {/* =======================================
                      ICON
                  ======================================= */}

                  <div className="more-item-icon">

                    {field.icon}

                  </div>


                  {/* =======================================
                      TEXT
                  ======================================= */}

                  <div className="more-item-content">

                    <div className="more-item-title">
                      {t(field.title)}
                    </div>


                    <div className="more-item-description">

                      {displayValue
                        ? displayValue
                        : t(field.description)}

                    </div>

                  </div>


                  {/* =======================================
                      RIGHT STATUS
                  ======================================= */}

                  <div className="more-item-status">

                    {secured ? (

                      <div className="secured-badge">

                        <span className="secured-word">
                          {t("Secure")}
                        </span>

                        <FaCheckCircle
                          className="secured-check"
                        />

                      </div>

                    ) : (

                      <FaChevronRight />

                    )}

                  </div>


                </button>

              );

            }
          )}

        </div>


        <div className="more-bottom-space" />

      </div>


      {/* ===================================================
          EDIT / SETUP MODAL
      =================================================== */}

      {selectedField && (

        <div
          className="security-modal-overlay"
          onMouseDown={(
            event
          ) => {

            if (
              event.target ===
              event.currentTarget
            ) {

              closeEditor();

            }

          }}
        >


          <div className="security-modal">


            {/* =============================================
                MODAL HEADER
            ============================================= */}

            <div className="security-modal-header">

              <div>

                <h2>
                  {t(selectedField.title)}
                </h2>

                <p>
                  {t(selectedField.description)}
                </p>

              </div>


              <button
                type="button"
                className="security-modal-close"
                onClick={
                  closeEditor
                }
                disabled={
                  saving
                }
                aria-label="Close"
              >

                <FaTimes />

              </button>


            </div>


            {/* =================================================
                SECURITY QUESTION
            ================================================= */}

            {selectedField.key ===
              "securityQuestion" ? (

              <div className="security-question-list">


                <div className="security-question-label">

                  {t("Select your security question")}

                </div>


                {/* =============================================
                    QUESTIONS
                ============================================= */}

                {securityQuestions.map(
                  (
                    question,
                    index
                  ) => (

                    <button
                      key={
                        index
                      }
                      type="button"
                      className={
                        selectedQuestion ===
                        question
                          ? "security-question-option selected"
                          : "security-question-option"
                      }
                      onClick={() =>
                        handleQuestionSelect(
                          question
                        )
                      }
                      disabled={
                        saving
                      }
                    >

                      <span className="security-question-number">

                        {
                          index + 1
                        }

                      </span>


                      <span className="security-question-text">

                        {
                          t(question)
                        }

                      </span>


                      {selectedQuestion ===
                        question && (

                        <span className="security-question-check">

                          ✓

                        </span>

                      )}

                    </button>

                  )
                )}


                {/* =================================================
                    ANSWER
                ================================================= */}

                {selectedQuestion && (

                  <div className="security-answer-wrapper">


                    <div className="security-answer-question">

                      <span>
                        {t("Selected Question")}
                      </span>

                      <strong>
                        {
                          t(selectedQuestion)
                        }
                      </strong>

                    </div>


                    <label>
                      {t("Your Answer")}
                    </label>


                    <input
                      type="text"
                      value={
                        inputValue
                      }
                      onChange={(
                        event
                      ) =>
                        setInputValue(
                          event.target.value
                        )
                      }
                      onKeyDown={
                        handleInputKeyDown
                      }
                      placeholder={
                        getAnswerPlaceholder()
                      }
                      autoFocus
                      disabled={
                        saving
                      }
                    />


                    <small>

                      Enter the answer that you
                      will remember for verification.

                    </small>

                  </div>

                )}

              </div>

            ) : (


              /* =================================================
                 NORMAL INPUT
              ================================================= */

              <div className="security-input-wrapper">

                <label>
                  {t(selectedField.title)}
                </label>


                <input
                  type={
                    selectedField.type
                  }
                  value={
                    inputValue
                  }
                  onChange={(
                    event
                  ) =>
                    setInputValue(
                      event.target.value
                    )
                  }
                  onKeyDown={
                    handleInputKeyDown
                  }
                  placeholder={
                    t(selectedField.placeholder)
                  }
                  autoFocus
                  disabled={
                    saving
                  }
                />

              </div>

            )}


            {/* =================================================
                MESSAGE
            ================================================= */}

            {message && (

              <div
                className={`security-message ${
                  (message.includes("successfully") || message.includes("mafanikio") || message.includes("succès") || message.includes("correctamente") || message.includes("sucesso") || message.includes("erfolgreich") || message.includes("bené"))
                    ? "success"
                    : "error"
                }`}
              >

                {message}

              </div>

            )}


            {/* =================================================
                ACTIONS
            ================================================= */}

            <div className="security-modal-actions">


              <button
                type="button"
                className="security-cancel-btn"
                onClick={
                  closeEditor
                }
                disabled={
                  saving
                }
              >

                {t("Cancel")}

              </button>


              <button
                type="button"
                className="security-save-btn"
                onClick={
                  handleSave
                }
                disabled={
                  saving
                }
              >

                {saving ? (

                  <>

                    <FaSpinner
                      className="security-spinner"
                    />

                    {t("Saving...")}

                  </>

                ) : (

                  <>

                    <FaSave />

                    {t("Save")}

                  </>

                )}

              </button>


            </div>


          </div>

        </div>

      )}


      {/* ===================================================
          BOTTOM NAVIGATION
      =================================================== */}

      <nav className="more-bottom-nav">


        <button
          type="button"
          className="more-nav-item"
          onClick={
            handleMenuClick
          }
        >

          <FaBars />

          <span>
            {t("Menu")}
          </span>

        </button>


        <button
          type="button"
          className="more-nav-item"
          onClick={
            handleTradesClick
          }
        >

          <FaExchangeAlt />

          <span>
            {t("Trades")}
          </span>

        </button>


        <button
          type="button"
          className="more-nav-item"
          onClick={
            handleMarketsClick
          }
        >

          <FaChartBar />

          <span>
            {t("Markets")}
          </span>

        </button>


        <button
          type="button"
          className="more-nav-item"
          onClick={
            handleNewsClick
          }
        >

          <FaNewspaper />

          <span>
            {t("News")}
          </span>

        </button>


        <button
          type="button"
          className="more-nav-item active"
          onClick={
            handleMoreClick
          }
        >

          <FaEllipsisH />

          <span>
            {t("More")}
          </span>

        </button>


      </nav>


    </div>

  );

}

